export var TypeActionOutskirtsBundle;
(function (TypeActionOutskirtsBundle) {
    TypeActionOutskirtsBundle["Load"] = "OutskirtsBundle > Load";
})(TypeActionOutskirtsBundle || (TypeActionOutskirtsBundle = {}));
export var actionOutskirtsBundleLoad = function (bundle) { return ({
    bundle: bundle,
    type: TypeActionOutskirtsBundle.Load,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/outskirts/actionOutskirtBundleLoad.ts
// module id = 836
// module chunks = 3